import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const StopwatchIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.414 5.531a.751.751 0 0 1 1.172.938l-2 2.5a.75.75 0 0 1-1.172-.938z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M10 1a1 1 0 0 1 1 1v.733q.517.271.975.625l.169-.127a1 1 0 0 1 1.4.198l1.203 1.596a1 1 0 0 1-.196 1.4l-.317.238A6.5 6.5 0 0 1 8 15 6.5 6.5 0 0 1 5 2.733V2a1 1 0 0 1 1-1zM8 3.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
			clipRule="evenodd"
		></path>
	</svg>
))
